/* eslint-disable @typescript-eslint/no-shadow */
import { useTheme } from '@mui/material';
import { ResponsiveBar } from '@nivo/bar';
import StatisticsBarDataProps from 'common/types/StatisticsBarDataProps';
import React from 'react';

type FinancesGraphProps = {
  data: StatisticsBarDataProps[];
  keys?: string[];
};


export default function OrderBar({ data, keys }:FinancesGraphProps) {
  const theme = useTheme();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  

  return (
        <ResponsiveBar
            data={data}
            margin={{ top: 50, right: 24, bottom: 50, left: 48 }}
            enableLabel={false}
            theme={{
              fontFamily: 'Mulish',
              fontSize: 16,
              textColor: theme.colors.primaryTextColor,
              axis: {
                domain: {
                  line: {
                    stroke: theme.colors.gray,
                    strokeWidth: 0,
                  },
                },
                ticks: {
                  line: {
                    stroke: theme.colors.gray,
                    strokeWidth: 0,
                  },
                },
              },
              grid: {
                line: {
                  stroke: theme.colors.gray,
                  strokeWidth: .2,
                },
              },
            }}
            groupMode='grouped'
            indexBy={'indexBy'}
            keys={keys}
            labelFormat={function (e: string | number) {
              return e + '€';
            }}
            isInteractive={true}
            borderRadius={4}
            padding={0.23}
            
            colors={({ id, data }) => data[`${id}Color`]}
            enableGridX={false}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            
          borderColor={{
            from: 'color',
            modifiers: [
              [
                'darker',
                1.6,
              ],
            ],
          }}
            
        />
  );
}